var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    rx: 10,
    fill: "#22CF4A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7495 33.125L20.3432 32.1875C19.8224 32.125 19.4836 31.8437 19.327 31.3437C19.1703 30.8437 19.2799 30.4167 19.6557 30.0625L32.437 17.8125C32.5411 17.7083 32.6661 17.6304 32.812 17.5787C32.9578 17.5271 33.1557 17.5008 33.4057 17.5C33.8224 17.5 34.1403 17.6771 34.3595 18.0312C34.5786 18.3854 34.5836 18.75 34.3745 19.125L30.2495 26.875L37.6557 27.8125C38.1765 27.875 38.5153 28.1563 38.672 28.6563C38.8286 29.1563 38.719 29.5833 38.3432 29.9375L25.562 42.1875C25.4578 42.2917 25.3328 42.37 25.187 42.4225C25.0411 42.475 24.8432 42.5008 24.5932 42.5C24.1765 42.5 23.8586 42.3229 23.6395 41.9688C23.4203 41.6146 23.4153 41.25 23.6245 40.875L27.7495 33.125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRange);
export default __webpack_public_path__ + "static/media/Range.ff3ec0007a148fbe821a326b8e35fb72.svg";
export { ForwardRef as ReactComponent };